import { render, staticRenderFns } from "./QuestionBasic.vue?vue&type=template&id=33566b64&scoped=true&"
import script from "./QuestionBasic.vue?vue&type=script&lang=js&"
export * from "./QuestionBasic.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBasic.vue?vue&type=style&index=0&id=33566b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33566b64",
  null
  
)

export default component.exports